import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Button, Tooltip } from 'antd';
import { union, contains, path, head, pathOr } from 'ramda';

import { openModalEventCreate, openModalStatePerson } from 'actions/modalActions';
import { getWorksheetList, getUser } from 'actions/asyncActions';
import { hasEventsAccess } from 'helpers/worksheetHelpers';
import { EMPLOYED_ENG, EMPLOYED_RUS } from 'constants/person';
import { PROJECT_PERSON_STATE_TYPES } from 'constants/project';
import CustomIcon from 'components/common/CustomIcon';

const stateToProps = ({ table: { worksheet: { selected } }, ...state }) => ({
    data: getWorksheetList.selectData(state),
    user: getUser.selectData(state),
    selected
});

const dispatchToProps = {
    openModalEventCreate,
    openModalStatePerson,
};

@connect(stateToProps, dispatchToProps)
export default class WorksheetListButtons extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        data: PropTypes.object.isRequired,
        selected: PropTypes.number,
        openModalEventCreate: PropTypes.func.isRequired,
        openModalStatePerson: PropTypes.func.isRequired,
    };

    getParticipators = () => {
        const { data } = this.props;

        return union((data.participators || []), data.responsible);
    }

    createEvent = () => {
        const { data, selected, openModalEventCreate } = this.props;

        const project = data.project || {};
        const person = data.people[selected];
        const participators = this.getParticipators();

        openModalEventCreate({
            project,
            person,
            participators,
        });
    }

    changePersonStatus = () => {
        const { data, selected, openModalStatePerson } = this.props;
        const person = data.people[selected];
        const project = pathOr({}, ['project'], data);
        const company = pathOr({}, ['project', 'company'], data);
        const position = head(data.position).text;
        const participators = this.getParticipators();
        const probation = data.probation;

        openModalStatePerson({
            personId: person.id,
            projectId: project.id,
            projectTypeId: project.projectTypeId,
            personName: person.text,
            organization: company.id,
            department: company.posdepartkey,
            position,
            participators,
            probation,
        });
    }

    notChangeState = (selected, data) => {
        if (selected && data) {
            const selectedPerson = data.people[selected];
            const personGroupName = selectedPerson.groupName;

            return contains(personGroupName, [EMPLOYED_ENG, EMPLOYED_RUS]) ? true : false;
        } else {
            return false;
        }
    }

    showStatusButton = () => {
        const projectTypeId = path(['project', 'projectTypeId'], this.props.data);

        return projectTypeId ? contains(projectTypeId, PROJECT_PERSON_STATE_TYPES) : false;
    }

    render() {
        const { user, data, selected } = this.props;

        const noEventsAccess = !hasEventsAccess(user, data);
        const disabled = noEventsAccess || !selected;
        const disabledPersonStatus = this.notChangeState(selected, data) || !selected;

        return (
            <Fragment>
                <Tooltip
                    title={ noEventsAccess && <Translate content="worksheet.only_participants_can_create" />}
                    placement="right"
                    overlayStyle={ { position: "fixed" } }
                >
                    <Button disabled={disabled} onClick={this.createEvent}>
                        <CustomIcon type="calendar-plus" />
                        <Translate component="span" content="worksheet.create" />
                    </Button>
                </Tooltip>
                <Tooltip
                    title={ noEventsAccess && <Translate content="worksheet.only_participants_can_change_state" />}
                    placement="right"
                    overlayStyle={ { position: "fixed" } }
                >
                { this.showStatusButton() && (
                    <Button
                        disabled={disabledPersonStatus}
                        onClick={this.changePersonStatus}
                    >
                        <CustomIcon type="user-with-arrow" />
                        <Translate component="span" content="worksheet.changePersonState" />
                    </Button>
                )}
                </Tooltip>
            </Fragment>
        );
    }
}
